import waitForDom from 'src/utils/waitForDom';
import header from './header';

waitForDom(() => {
  header();
});
